module.exports = __webpack_public_path__ + "img/case6.fd1f6836.jpg";